var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"form-input",attrs:{"type":_vm.inputType,"placeholder":_vm.placeholder,"maxlength":_vm.maxlength},domProps:{"value":_vm.value},on:{"input":_vm.handlerInput,"keyup":_vm.handlerKeyup}})}
var staticRenderFns = []

export { render, staticRenderFns }